<template>
  <div id="app">
    <!-- <Index />  -->
    <router-view></router-view> <!-- 添加 router-view 标签 -->
  </div>
</template>

<script>
// import Index from './components/IndexInfo.vue';

export default {
  components: {
    // Index,
  },
};
</script>